







































































































import { Icon } from 'vant';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { NewsItemTypes } from '../api/util';
Vue.use(Icon);
@Component
export default class NewsItem extends Vue {
  sizeMap: any = {
    2: 'bigImg',
    3: 'middleImg',
    14: 'halfImg',
  };
  @Prop({ default: () => ({}) }) newsObj!: NewsItemTypes;

  /**
   * timeAgo
   */
  public timeAgo(time: number) {
    // 计算已经过去多久
    const now = new Date().getTime();
    const timeAgo = now - time * 1000;
    const day = Math.floor(timeAgo / (24 * 3600 * 1000));
    const hour = Math.floor((timeAgo % (24 * 3600 * 1000)) / (3600 * 1000));
    const minute = Math.floor((timeAgo % (3600 * 1000)) / (60 * 1000));
    const second = Math.floor((timeAgo % (60 * 1000)) / 1000);
    if (day > 3) {
      return new Date(time * 1000).toLocaleDateString();
    }
    if (day > 0) {
      return `${day}天前`;
    }
    if (hour > 0) {
      return `${hour}小时前`;
    }
    if (minute > 0) {
      return `${minute}分钟前`;
    }
    if (second > 0) {
      return `${second}秒前`;
    }
    return '刚刚';
  }

  public toDetail() {
    // if (this.newsObj.dataType === 7) {
    //   window.location.href = this.newsObj.targetUrl.startsWith('http')
    //     ? this.newsObj.targetUrl
    //     : 'https://' + this.newsObj.targetUrl;
    // } else {
    //   this.$router.push(
    //     'rule?classid=' + this.newsObj.classId + '&newid=' + this.newsObj.id,
    //   );
    // }
    const url = this.newsObj.targetUrl;
    window.location.href = url;
  }
}
